<template>
  <div style="position: relative;">
    <el-form ref="courseListFilter" :model="courseList" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="课程名称" prop="formFilter.courseName">
          <el-input class="filter-item" v-model="courseList.formFilter.courseName"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="授课专家" prop="formFilter.teachName">
          <el-input class="filter-item" v-model="courseList.formFilter.teachName"
            :clearable="true" placeholder=""
          />
        </el-form-item>
<!--        <el-form-item label="审核状态" prop="formFilter.auditStatus">-->
<!--          <el-select class="filter-item" v-model="courseList.formFilter.auditStatus" :clearable="true" filterable-->
<!--            placeholder="" :loading="courseList.auditStatus.impl.loading"-->
<!--            @visible-change="courseList.auditStatus.impl.onVisibleChange"-->
<!--            @change="onAuditStatusValueChange">-->
<!--            <el-option v-for="item in courseList.auditStatus.impl.dropdownList" :key="item.id"-->
<!--              :value="item.id" :label="item.name"-->
<!--            />-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="是否上架" prop="formFilter.upFlag">
          <el-select class="filter-item" v-model="courseList.formFilter.upFlag" :clearable="true" filterable
            placeholder="" :loading="courseList.upFlag.impl.loading"
            @visible-change="courseList.upFlag.impl.onVisibleChange"
            @change="onUpFlagValueChange">
            <el-option v-for="item in courseList.upFlag.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetCourseList">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshCourseList(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('courseList:courseList:coursePageEditAdd')"
          @click="onCoursePageEditAddClick()">
          新增
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="course" :data="courseList.Course.impl.dataList" :size="defaultFormItemSize" @sort-change="courseList.Course.impl.onSortChange"
          header-cell-class-name="table-header-gray"
          highlight-current-row @current-change="courseList.Course.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="courseList.Course.impl.getTableIndex" />
          <el-table-column label="课程名称" prop="courseName">
          </el-table-column>
          <el-table-column label="授课专家" prop="teachName">
          </el-table-column>
          <el-table-column label="课程封面" min-width="100px">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.courseImages, {id: scope.row.id, fieldName: 'courseImages', asImage: true})"
                :preview-src-list="getPictureList(scope.row.courseImages, {id: scope.row.id, fieldName: 'courseImages', asImage: true})"
                class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="总课时长" prop="totalTime">
          </el-table-column>
          <el-table-column label="是否上架" prop="upFlagDictMap.name">
          </el-table-column>
<!--          <el-table-column label="审核状态" prop="auditStatusDictMap.name">-->
<!--          </el-table-column>-->
          <el-table-column label="创建时间" prop="createTime">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button @click.stop="onCoursePageEditClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('courseList:courseList:coursePageEdit')">
                查看编辑
              </el-button>
              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('courseList:courseList:delete')">
                删除
              </el-button>
              <el-button @click.stop="changeUpFlag(scope.row, '1', '上架')" type="text" :size="defaultFormItemSize"
                         v-if="scope.row.upFlag === '0'">
                上架
              </el-button>
              <el-button @click.stop="changeUpFlag(scope.row, '0', '下架')" type="text" :size="defaultFormItemSize"
                         v-if="scope.row.upFlag === '1'">
                下架
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="courseList.Course.impl.totalCount"
            :current-page="courseList.Course.impl.currentPage"
            :page-size="courseList.Course.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="courseList.Course.impl.onCurrentPageChange"
            @size-change="courseList.Course.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { CourseController, DictionaryController } from '@/api';

export default {
  name: 'courseList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      courseList: {
        formFilter: {
          courseName: undefined,
          teachName: undefined,
          auditStatus: undefined,
          upFlag: undefined
        },
        formFilterCopy: {
          courseName: undefined,
          teachName: undefined,
          auditStatus: undefined,
          upFlag: undefined
        },
        Course: {
          impl: new TableWidget(this.loadCourseWidgetData, this.loadCourseVerify, true, true, 'createTime', 1)
        },
        auditStatus: {
          impl: new DropdownWidget(this.loadAuditStatusDropdownList)
        },
        upFlag: {
          impl: new DropdownWidget(this.loadUpFlagDropdownList)
        },
        isInit: false
      }
    }
  },
  methods: {
    onResetCourseList () {
      this.$refs.courseListFilter.resetFields();
      this.refreshCourseList(true);
    },
    /**
     * 课程表数据获取函数，返回Promise
     */
    loadCourseWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        courseDtoFilter: {
          courseName: this.courseList.formFilterCopy.courseName,
          teachName: this.courseList.formFilterCopy.teachName,
          auditStatus: this.courseList.formFilterCopy.auditStatus,
          upFlag: this.courseList.formFilterCopy.upFlag
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        CourseController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.courseList.Course.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.courseList.Course.impl.currentRow.id, 'id');
              this.$refs.course.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 课程表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadCourseVerify () {
      this.courseList.formFilterCopy.courseName = this.courseList.formFilter.courseName;
      this.courseList.formFilterCopy.teachName = this.courseList.formFilter.teachName;
      this.courseList.formFilterCopy.auditStatus = this.courseList.formFilter.auditStatus;
      this.courseList.formFilterCopy.upFlag = this.courseList.formFilter.upFlag;
      return true;
    },
    /**
     * 审核状态下拉数据获取函数
     */
    loadAuditStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAuditStatusDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 审核状态选中值改变
     */
    onAuditStatusValueChange (value) {
    },
    /**
     * 是否上架下拉数据获取函数
     */
    loadUpFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 是否上架选中值改变
     */
    onUpFlagValueChange (value) {
    },
    /**
     * 更新课程管理
     */
    refreshCourseList (reloadData = false) {
      if (reloadData) {
        this.courseList.Course.impl.refreshTable(true, 1);
      } else {
        this.courseList.Course.impl.refreshTable();
      }
      if (!this.courseList.isInit) {
        // 初始化下拉数据
      }
      this.courseList.isInit = true;
    },
    /**
     * 查看编辑
     */
    onCoursePageEditClick (row) {
      let params = {
        id: row.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'coursePageEdit', query: params});
    },
    /**
     * 新增
     */
    onCoursePageEditAddClick () {
      let params = {};

      params.closeVisible = 1;
      this.$router.push({name: 'coursePageEdit', query: params});
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      CourseController.delete(this, params).then(res => {
        this.$message.success('删除成功');
        this.courseList.Course.impl.refreshTable(false, 1);
      }).catch(e => {});
    },
    /**
     * 改变发布状态
     */
    changeUpFlag (row, upFlag, mes) {
      let params = {
        courseDto: {
          ...row
        }
      };
      params.courseDto.upFlag = upFlag
      this.$confirm('是否' + mes + '?').then(res => {
        CourseController.update(this, params).then(res => {
          this.$message.success(mes + '成功');
          this.courseList.Course.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    onResume () {
      this.refreshCourseList();
    },
    initFormData () {
    },
    formInit () {
      this.refreshCourseList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
